import React from "react";
import { Checkbox } from "@assets/spa/control/checkbox";
export function ForminatorConsent(props) {
    const { value, onChange, consent_description } = props;
    return React.createElement(Checkbox, { label: React.createElement("div", { dangerouslySetInnerHTML: { __html: consent_description } }), checked: value === 'checked', onChange: (checked) => {
            onChange(checked ? "checked" : undefined);
        } });
}
